(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["date-atelier-cookie-consent"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-da-cookies]';

    const removeOlderPortal = (root) => {
      const sectionId = root.dataset.daSectionId;
      document.querySelectorAll(selector).forEach((candidate) => {
        if (candidate === root) return;
        if (candidate.dataset.daSectionId !== sectionId) return;
        if (candidate.parentElement === document.body) candidate.remove();
      });
    };

    const portalToBody = (root) => {
      removeOlderPortal(root);
      if (root.parentElement !== document.body) document.body.appendChild(root);
    };

    const init = (root) => {
      if (!root || root.dataset.initialized === 'true') return;

      portalToBody(root);
      root.dataset.initialized = 'true';

      const banner = root.querySelector('[data-da-banner]');
      const dialog = root.querySelector('[data-da-dialog]');
      const isDesignMode = root.dataset.designMode === 'true';
      const isCookieNoticePage = root.dataset.cookieNoticePage === 'true';
      const editorPreview = root.dataset.editorPreview;
      const inputs = {
        preferences: root.querySelector('[data-da-consent="preferences"]'),
        analytics: root.querySelector('[data-da-consent="analytics"]'),
        marketing: root.querySelector('[data-da-consent="marketing"]')
      };

      let privacy = null;
      let closingTimer = null;

      const animationMs = 500;

      const showBanner = () => {
        window.clearTimeout(closingTimer);
        banner.hidden = false;
        requestAnimationFrame(() => banner.classList.add('is-visible'));
      };

      const hideBannerImmediately = () => {
        banner.classList.remove('is-visible');
        banner.hidden = true;
      };

      const hideBanner = () => {
        banner.classList.remove('is-visible');
        window.setTimeout(() => {
          banner.hidden = true;
        }, 260);
      };

      const setCheckboxes = (values = {}) => {
        Object.entries(inputs).forEach(([key, input]) => {
          if (!input) return;
          input.checked = values[key] === true || values[key] === 'yes';
        });
      };

      const readCurrentConsent = () => {
        if (!privacy || typeof privacy.currentVisitorConsent !== 'function') return {};
        return privacy.currentVisitorConsent() || {};
      };

      const closePreferences = ({ returnToBanner = true } = {}) => {
        if (!dialog.open) {
          if (returnToBanner) showBanner();
          return;
        }

        dialog.classList.remove('is-open');

        const completeClose = () => {
          if (dialog.open) dialog.close();
          if (returnToBanner) showBanner();
        };

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          completeClose();
          return;
        }

        window.clearTimeout(closingTimer);
        closingTimer = window.setTimeout(completeClose, animationMs);
      };

      const openPreferences = () => {
        window.clearTimeout(closingTimer);
        if (!isDesignMode) setCheckboxes(readCurrentConsent());

        hideBannerImmediately();

        if (!dialog.open) dialog.showModal();

        requestAnimationFrame(() => {
          requestAnimationFrame(() => dialog.classList.add('is-open'));
        });
      };

      const finish = () => {
        closePreferences({ returnToBanner: false });
        hideBanner();
        document.dispatchEvent(new CustomEvent('dateatelier:consent-changed'));
      };

      const applyConsent = (values) => {
        if (isDesignMode) {
          finish();
          return;
        }

        if (!privacy || typeof privacy.setTrackingConsent !== 'function') return;
        privacy.setTrackingConsent(values, finish);
      };

      const acceptAll = () => applyConsent({
        preferences: true,
        analytics: true,
        marketing: true
      });

      const rejectAll = () => applyConsent({
        preferences: false,
        analytics: false,
        marketing: false
      });

      const savePreferences = () => applyConsent({
        preferences: Boolean(inputs.preferences && inputs.preferences.checked),
        analytics: Boolean(inputs.analytics && inputs.analytics.checked),
        marketing: Boolean(inputs.marketing && inputs.marketing.checked)
      });

      root.querySelector('[data-da-accept]')?.addEventListener('click', acceptAll);
      root.querySelector('[data-da-reject]')?.addEventListener('click', rejectAll);
      root.querySelector('[data-da-open-preferences]')?.addEventListener('click', openPreferences);
      root.querySelector('[data-da-close]')?.addEventListener('click', () => closePreferences());
      root.querySelector('[data-da-save]')?.addEventListener('click', savePreferences);
      root.querySelector('[data-da-modal-accept]')?.addEventListener('click', acceptAll);
      root.querySelector('[data-da-modal-reject]')?.addEventListener('click', rejectAll);

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closePreferences();
      });

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closePreferences();
      });

      window.DateAtelierCookies = window.DateAtelierCookies || {};
      window.DateAtelierCookies.openPreferences = openPreferences;

      if (isDesignMode) {
        setCheckboxes({ preferences: true, analytics: false, marketing: false });

        if (editorPreview === 'preferences') {
          openPreferences();
        } else {
          showBanner();
        }
        return;
      }

      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        (error) => {
          if (error || !window.Shopify.customerPrivacy) return;
          privacy = window.Shopify.customerPrivacy;

          if (isCookieNoticePage) return;

          const consent = readCurrentConsent();
          const consentKeys = ['preferences', 'analytics', 'marketing'];
          const needsDecision = consentKeys.some(
            (key) => consent[key] !== 'yes' && consent[key] !== 'no'
          );

          if (!needsDecision) return;

          if (typeof privacy.shouldShowBanner === 'function' && privacy.shouldShowBanner()) {
            showBanner();
            return;
          }

          const region = typeof privacy.getRegion === 'function'
            ? String(privacy.getRegion() || '').toUpperCase()
            : '';

          const country = region.slice(0, 2);
          const optInCountries = new Set([
            'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU',
            'IS','IE','IT','LV','LI','LT','LU','MT','NL','NO','PL','PT','RO',
            'SK','SI','ES','SE','GB'
          ]);

          if (region === '' || optInCountries.has(country)) {
            showBanner();
          }
        }
      );
    };

    const initAll = () => document.querySelectorAll(selector).forEach(init);

    if (!window.__dateAtelierCookieTriggerBound) {
      window.__dateAtelierCookieTriggerBound = true;

      document.addEventListener('click', (event) => {
        const explicitTrigger = event.target.closest('[data-date-atelier-cookie-preferences]');
        const cookieNoticeLink = event.target.closest('a[href*="/pages/cookie-notice"]');
        const isFooterPreferenceLink = cookieNoticeLink
          && cookieNoticeLink.textContent.trim().toLowerCase() === 'cookie preferences';

        if (!explicitTrigger && !isFooterPreferenceLink) return;

        event.preventDefault();
        window.DateAtelierCookies?.openPreferences?.();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches?.(selector)
        ? event.target
        : event.target.querySelector?.(selector);

      if (root) init(root);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const sectionId = event.detail?.sectionId;
      if (!sectionId) return;

      document.querySelectorAll(selector).forEach((root) => {
        if (root.dataset.daSectionId === String(sectionId) && root.parentElement === document.body) {
          root.remove();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["date-atelier-sustainability"] && !Shopify.designMode) return;
  try {
    
  const initialiseDateAtelierSustainability = (root) => {
    if (!root || root.dataset.daSustainabilityReady === 'true') return;
    root.dataset.daSustainabilityReady = 'true';

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const revealTargets = root.querySelectorAll('[data-da-reveal], .da-sustainability__mission-inner');

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealTargets.forEach((target) => target.classList.add('is-visible'));
    } else {
      root.classList.add('is-motion-ready');
      const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      revealTargets.forEach((target) => revealObserver.observe(target));
    }

    const parallaxTargets = [...root.querySelectorAll('[data-da-parallax]')];
    let ticking = false;

    const updateParallax = () => {
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      parallaxTargets.forEach((target) => {
        const rect = target.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > viewportHeight) return;
        const progress = ((rect.top + rect.height / 2) - viewportHeight / 2) / ((viewportHeight + rect.height) / 2);
        const range = Number(target.dataset.daParallaxRange || 10);
        const offset = Math.max(-range, Math.min(range, progress * range));
        target.style.setProperty('--da-parallax-y', `${offset}%`);
      });
      ticking = false;
    };

    const requestParallax = () => {
      if (ticking || reduceMotion) return;
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    };

    if (!reduceMotion && parallaxTargets.length) {
      updateParallax();
      window.addEventListener('scroll', requestParallax, { passive: true });
      window.addEventListener('resize', requestParallax, { passive: true });
    }

    const subnavigation = root.querySelector('[data-da-subnav]');
    const subnavigationToggle = subnavigation?.querySelector('[data-da-subnav-toggle]');
    const subnavigationClose = subnavigation?.querySelector('[data-da-subnav-close]');
    const subnavigationContent = subnavigation?.querySelector('[data-da-subnav-content]');

    const setSubnavigation = (open) => {
      if (!subnavigation || !subnavigationToggle || !subnavigationContent) return;
      subnavigation.classList.toggle('is-open', open);
      subnavigationToggle.setAttribute('aria-expanded', String(open));
      subnavigationContent.inert = !open;
    };

    if (subnavigation && subnavigationToggle && subnavigationContent) {
      setSubnavigation(false);
      subnavigationToggle.addEventListener('click', () => setSubnavigation(!subnavigation.classList.contains('is-open')));
      subnavigationClose?.addEventListener('click', () => {
        setSubnavigation(false);
        subnavigationToggle.focus();
      });
      subnavigation.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !subnavigation.classList.contains('is-open')) return;
        setSubnavigation(false);
        subnavigationToggle.focus();
      });

      subnavigation.querySelectorAll('a[href^="#"]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = root.querySelector(link.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          setSubnavigation(false);
          target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        });
      });
    }

    root.querySelectorAll('[data-da-dialog-open]').forEach((button) => {
      button.addEventListener('click', () => {
        const dialog = document.getElementById(button.dataset.daDialogOpen);
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      });
    });

    root.querySelectorAll('.da-sustainability__dialog').forEach((dialog) => {
      dialog.querySelector('[data-da-dialog-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    });

    if (reduceMotion) root.querySelectorAll('video[autoplay]').forEach((video) => video.pause());
  };

  document.querySelectorAll('[data-da-sustainability]').forEach(initialiseDateAtelierSustainability);
  document.addEventListener('shopify:section:load', (event) => {
    initialiseDateAtelierSustainability(event.target.querySelector('[data-da-sustainability]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tda-partner-terms"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tda-partner-terms')) {
  customElements.define('tda-partner-terms', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.dialog = this.querySelector('dialog');
      window.addEventListener('message', event => {
        if (event.origin !== 'https://account.thedateatelier.co.uk' || event.data?.type !== 'tda-partner-terms-open') return;
        const frame = document.querySelector('[data-partner-frame]');
        if (!frame || frame.contentWindow !== event.source) return;
        this.invokingFrame = frame;
        this.open();
      }, options);
      this.querySelector('[data-partner-terms-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        const rect = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow ?? '';
        if (this.returnFocus?.isConnected) this.returnFocus.focus({preventScroll: true});
        this.invokingFrame?.contentWindow?.postMessage({type: 'tda-partner-terms-closed'}, 'https://account.thedateatelier.co.uk');
        this.invokingFrame = null;
      }, options);
      const openLinkedTerms = () => { if (['#terms', '#partner-terms'].includes(location.hash)) this.open(); };
      window.addEventListener('hashchange', openLinkedTerms, options);
      document.addEventListener('shopify:section:select', event => { if (this.closest('.shopify-section') === event.target) this.open(); }, options);
      openLinkedTerms();
    }
    open() {
      if (this.dialog.open) return;
      this.returnFocus = document.activeElement instanceof HTMLElement && document.activeElement !== document.body ? document.activeElement : null;
      this.previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.dialog.showModal();
      this.dialog.scrollTop = 0;
    }
    disconnectedCallback() {
      if (this.dialog?.open) document.body.style.overflow = this.previousOverflow ?? '';
      this.controller?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tda-referral-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tda-referral-hero')) {
  customElements.define('tda-referral-hero', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('[data-ref-open]');
      const close = () => this.dialog.close();
      this.opener.addEventListener('click', () => this.open(), options);
      this.querySelector('[data-ref-close]').addEventListener('click', close, options);
      this.dialog.addEventListener('click', event => {
        const rect = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow ?? '';
        this.opener.focus({preventScroll:true});
      }, options);
      document.addEventListener('shopify:block:select', event => {if (this.contains(event.target)) this.open();}, options);
      const openLinkedTerms = () => { if (location.hash === '#terms') this.open(); };
      window.addEventListener('hashchange', openLinkedTerms, options);
      openLinkedTerms();
    }
    open() {
      if (this.dialog.open) return;
      this.previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.dialog.showModal();
    }
    disconnectedCallback() {
      if (this.dialog?.open) document.body.style.overflow = this.previousOverflow ?? '';
      this.controller?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
